module.exports = __webpack_public_path__ + "img/car_00046.a433d131.jpg";